/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core";
import { Person } from "@material-ui/icons";
import { SearchIcon } from "App/Assets";
import { MasterButton } from "App/Component/ui";
import React, { useCallback, useState } from "react";
import ModalNomorAntrian from "./ModalNomorAntrian";
import ModalBooking from "./ModalBooking";
import ModalKunjunganBaru from "./ModalKunjunganBaru";
import { defaultToastError } from "App/utils/helpers";

function ModalButtonBookAndKunjBaru({
  handleClickSelectBooking,
  handleClickSelectKunjBaru,
  handleClickReset,
  formData,
  setFormData,
}) {
  const [showModalNomorAntrian, setShowModalNomorAntrian] = useState(false);
  const [showModalBooking, setShowModalBooking] = useState(false);
  const [showModalKunjunganBaru, setShowModalKunjunganBaru] = useState(false);

  const handleClickButtonBooking = () => {
    setShowModalBooking(!showModalBooking);
  };

  const handleClickButtonKunjunganBaru = () => {
    setShowModalKunjunganBaru(!showModalKunjunganBaru);
  };

  const handleClickSelectBook = (row) => {
    if(row.status_jadwal === 1){
    handleClickSelectBooking(row);
    setShowModalNomorAntrian(true);
    setShowModalBooking(false);
    }else{
      defaultToastError(`Tidak Dapat Melanjutkan Karena Jadwal Dokter Dalam Status ${row.status_jadwal_string}`)
    }

  };

  const handleClickSelectKunjungan = (row) => {
    handleClickSelectKunjBaru(row);
    setShowModalNomorAntrian(true);
    setShowModalKunjunganBaru(false);
  };

  const handleKeyPress = useCallback((event) => {
    if (event.key === "F2") {
      setShowModalBooking(true);
      setShowModalKunjunganBaru(false);
    }

    if (event.key === "F4") {
      setShowModalKunjunganBaru(true);
      setShowModalBooking(false);
    }

    if (event.key === "F6") {
      handleClickReset();
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <>
      <ModalNomorAntrian
        setShowModal={() => setShowModalNomorAntrian(false)}
        showModal={showModalNomorAntrian}
        formData={formData}
        setFormData={setFormData}
      />

      {showModalBooking && (
        <ModalBooking
          setShowModal={() => setShowModalBooking(false)}
          handleClickSelect={handleClickSelectBook}
        />
      )}

      {showModalKunjunganBaru && (
        <ModalKunjunganBaru
          formData={formData}
          setFormData={setFormData}
          handleClickSelect={handleClickSelectKunjungan}
          setShowModal={() => setShowModalKunjunganBaru(false)}
        />
      )}

      <Grid item xs={6}>
        <Grid container direction='row' justifyContent='flex-end'>
          <MasterButton
            type={"button"}
            color='warning'
            name='Cari Booking'
            size='xs'
            withIcon={true}
            style={{ marginLeft: 20 }}
            icon={<SearchIcon width={"15"} height={"15"} fill={"#fff"} />}
            onClick={handleClickButtonBooking}
          />

          <MasterButton
            type={"button"}
            color='green'
            name='Kunjungan Baru'
            size='xs'
            withIcon={true}
            style={{ marginLeft: 10 }}
            icon={
              <Person
                style={{
                  width: "15px",
                }}
              />
            }
            onClick={handleClickButtonKunjunganBaru}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default ModalButtonBookAndKunjBaru;
